import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-feedback',
  imports: [],
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.css'
})
export class FeedbackComponent {
  @Output() openFeedbackModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor () { }

  ngOnInit (): void {
  }

  oncloseModal () {
    this.openFeedbackModal.emit(false);
  }

}

